import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { API_ENDPOINTS, apiRequest } from '../config/api';
import LoadingSpinner from './LoadingSpinner';

const ProtectedRoute = ({ children }) => {
  const [checked, setChecked] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const checkLogin = async () => {
      try {
        await apiRequest(API_ENDPOINTS.AUTH.ME, { credentials: 'include' });
        setIsLoggedIn(true);
      } catch {
        setIsLoggedIn(false);
      } finally {
        setChecked(true);
      }
    };
    checkLogin();
  }, []);

  if (!checked) return <LoadingSpinner />;
  if (!isLoggedIn) return <Navigate to="/login" replace />;
  return children;
};

export default ProtectedRoute; 